import axiosInstance from "./axiosInstance";



export const getDaypass = async () => {
    return await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/daypass`,
        {
        withCredentials: true,
        }
    );
}

export const getDaypassByDate = async (date) => {
    return await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/daypass/fecha`,
        {
            params: { fecha: date },
            withCredentials: true,
        }
    );
}

export const getMyDaypassByDate = async(date) => {
    return await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/daypass/fecha/me`,
        {
            params: { fecha: date },
            withCredentials: true,
        }
    );
}

export const getDaypassByDateAdmin = async (fecha = null, fechaInicio = null, fechaFin = null, idTitular = null, page=null) => {
    let params = {};
    if (fecha) {
        params.fecha = fecha;
    }
    if (fechaInicio) {
        params.fechaInicio = fechaInicio;
    }
    if (fechaFin) {
        params.fechaFin = fechaFin;
    } 
    if (idTitular) {
        params.idTitular = idTitular;
    }
    if (page) {
        params.page = page;
    }
    return await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/daypass/admin/fechas`,
        {
            params: params,
            withCredentials: true,
        }
    );
}

export const getUltimaReservacion = async () => {
    return await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/ultimaReservacion`,
        {
            withCredentials: true,
        }
    )
}

export const postDaypass = async (data) => {
    return await axiosInstance.post(
        `${process.env.REACT_APP_BASE_URL}/daypass/reservar`,
        data,
        {
        withCredentials: true,
        }
    );
}

export const getActividadMembresia = async () => {
    return await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/actividadMembresia`,
        {
            withCredentials: true,
        }
    );
}

export const getActividadMembresiaByTitular = async (titular) => {
    return await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/actividadMembresia/titular/${titular}`,
        {
            withCredentials: true,
        }
    );
}